import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class BasicInfoService {

  env = environment;
  constructor(private readonly http: HttpClient) { }

  validateUserBasicInfoWithBureau() {
    return this.http.post(this.env.webApiUrl + 'api/validatebureaubasicinfo/ValidateUserBasicInfoWithBureau', null);
  }

  validateNewCellNumberWithBureau(newCellNumber: string) {
    return this.http.post(this.env.webApiUrl + 'api/validatebureaubasicinfo/ValidateNewCellNumberWithBureau', { NewCellNumber: newCellNumber });
  }

  validateUserBasicInfoWithBureauWithToken(token: string): Observable<any> {
    return from(
      fetch(this.env.webApiUrl + 'api/validatebureaubasicinfo/ValidateUserBasicInfoWithBureau', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(async (response) => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
    );
  }
}
